import React from 'react'
import { withIcon } from '../../withIcon'

function ChevronDownIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.18306 8.44702C5.42714 8.19507 5.82286 8.19507 6.06694 8.44702L11.625 14.1844L17.1831 8.44702C17.4271 8.19507 17.8229 8.19507 18.0669 8.44702C18.311 8.69897 18.311 9.10746 18.0669 9.35942L12.0669 15.553C11.8229 15.8049 11.4271 15.8049 11.1831 15.553L5.18306 9.35942C4.93898 9.10746 4.93898 8.69897 5.18306 8.44702Z" fill={color}/>
    </svg>
  )
}

export default withIcon(ChevronDownIcon)
